"use client";

import { useEffect, useState, type ReactNode } from "react";

import { TWIN_LIVE_MARK_SETTLE_MS } from "@/components/app/twin/twin-live-mark";

/*
 * A row's avatar while its run is working: the person's avatar with the Twin
 * mark breathing beside it, stacked as other avatar stacks are (`working`).
 * When the run ends the mark settles, then the row's own avatar, with its
 * provenance badges, lands in its place.
 */
export function FeedRunAvatar({
  running,
  working,
  children,
}: {
  running: boolean;
  working: ReactNode;
  children: ReactNode;
}) {
  const [stacked, setStacked] = useState(running);
  const [landed, setLanded] = useState(false);
  useEffect(() => {
    if (running) {
      setStacked(true);
      setLanded(false);
      return;
    }
    if (!stacked) return;
    const timer = window.setTimeout(() => {
      setStacked(false);
      setLanded(true);
    }, TWIN_LIVE_MARK_SETTLE_MS);
    return () => window.clearTimeout(timer);
  }, [running, stacked]);

  if (stacked) return working;
  if (!landed) return children;
  return (
    <span className="flex shrink-0 self-start animate-in fade-in-0 zoom-in-75 duration-300 motion-reduce:animate-none">
      {children}
    </span>
  );
}
